import { currentDevelopmentUIState } from './dev-ui-state.ts';

export function getSpaceId() {
  return currentDevelopmentUIState.containerId;
}

export function getSpaceKey() {
  return currentDevelopmentUIState.containerKey;
}
